import * as React from 'react';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import SettingsIcon from '@material-ui/icons/Settings';
import { useMediaQuery, Theme, Box } from '@material-ui/core';
import {
    useTranslate,
    DashboardMenuItem,
    MenuItemLink,
    MenuProps,
} from 'react-admin';

import products from '../projects';
import posts from '../posts';
import appConfiguration from '../landing-page';
import SubMenu from './SubMenu';
import { AppState } from '../types';
import artists from '../artists';
import payments from '../payments';
import messages from '../messages';

type MenuName = 'menuLandingPage' | 'menuSales' | 'menuCustomers';

const Menu: FC<MenuProps> = ({ onMenuClick, logout, dense = false }) => {
    const [state, setState] = useState({
        menuLandingPage: true,
        menuClidashboard: true,
    });
    const translate = useTranslate();
    const isXSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('xs')
    );
    const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);
    useSelector((state: AppState) => state.theme); // force rerender on theme change

    const handleToggle = (menu: MenuName) => {
        setState(state => ({ ...state, [menu]: !state[menu] }));
    };

    return (
        <Box mt={1}>
            {' '}
            {/*<DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} />*/}
            <MenuItemLink
                to={`/partners`}
                primaryText={translate(`resources.partners.name`, {
                    smart_count: 2,
                })}
                leftIcon={<products.icon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
                dense={dense}
            />
            <MenuItemLink
                to={`/payments`}
                primaryText={translate(`resources.payments.name`, {
                    smart_count: 2,
                })}
                leftIcon={<payments.icon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
                dense={dense}
            />
            <SubMenu
                handleToggle={() => handleToggle('menuLandingPage')}
                isOpen={state.menuLandingPage}
                sidebarIsOpen={open}
                name="pos.menu.landingPage"
                icon={<products.icon />}
                dense={dense}
            >
                <MenuItemLink
                    to={`/blogs`}
                    primaryText={translate(`resources.posts.name`, {
                        smart_count: 2,
                    })}
                    leftIcon={<posts.icon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/projects`}
                    primaryText={translate(`resources.projects.name`, {
                        smart_count: 2,
                    })}
                    leftIcon={<products.icon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/artists`}
                    primaryText={translate(`pos.menu.artists`, {
                        smart_count: 2,
                    })}
                    leftIcon={<artists.icon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/messages`}
                    primaryText={translate(`pos.menu.messages`, {
                        smart_count: 2,
                    })}
                    leftIcon={<messages.icon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/landing-page/configuration`}
                    primaryText={translate(`pos.menu.configuration`, {
                        smart_count: 2,
                    })}
                    leftIcon={<appConfiguration.icon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
            </SubMenu>
            {isXSmall && (
                <MenuItemLink
                    to="/configuration"
                    primaryText={translate('pos.configuration')}
                    leftIcon={<SettingsIcon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
            )}
            {isXSmall && logout}
        </Box>
    );
};

export default Menu;
